import styled, { css } from 'styled-components';

import { COLOURS, media, shouldForwardProp } from '@belong/themes';

import { PictureContainer } from '../../media';
import { Copy } from '../../styles/Typography';

import { ITileHeaderProps } from './TileHeader';

export const Wrapper = styled.div<Pick<ITileHeaderProps, 'verticalAlign'>>`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  ${({ verticalAlign }) => (verticalAlign ? `align-items: ${verticalAlign};` : '')};
`;

export const Image = styled(PictureContainer)<Pick<ITileHeaderProps, 'isSmallImg' | 'disabled' | 'imageAriaHidden'>>`
  flex-shrink: 0;
  order: 1;
  object-fit: ${({ contentType }) => (contentType === 'svg' ? 'contain' : 'cover')};
  margin-right: 0.8rem;
  ${({ disabled }) => (disabled ? `opacity: 0.4;` : '')}

  ${media('xs')`
    width: 7.2rem;
    height: 7.2rem;
  `}

  ${({ isSmallImg }) =>
    isSmallImg
      ? ''
      : media('md')`
        width:9.6rem;
        height:9.6rem;
      `}
`;

type ITileHeadercontent = Pick<ITileHeaderProps, 'disabled' | 'withStatus'>;
export const Content = styled.div.withConfig({
  shouldForwardProp: shouldForwardProp<ITileHeadercontent>('disabled')
})<ITileHeadercontent>`
  ${({ disabled }) => (disabled ? `opacity: 0.4;` : '')}
  order: 3;

  ${media('xs')`
    flex: ${({ withStatus }) => (withStatus ? '0 0 100%' : '0 0 70%')};
  `}

  ${media('sm')`
    flex: ${({ withStatus }) => (withStatus ? '0 0 100%' : '0 0 75%')};
  `}

  ${media('md')`
    flex: ${({ withStatus }) => (withStatus ? '0 0 100%' : '0 0 80%')};
  `}

  ${media('lg')`
    order: 2;
    flex: ${({ withStatus }) => (withStatus ? '0 0 auto' : '0 0 80%')};
  `}
  
  * {
    ${({ disabled }) => (disabled ? `color: ${COLOURS.GREY_500};` : '')}
  }
`;

export const Status = styled.div`
  margin-left: auto;

  ${media('xs')`
    order: 2;
  `}

  ${media('sm')`
    order: 2;
  `}

  ${media('md')`
    order: 2;
  `}

  ${media('lg')`
    order: 3;
  `}
`;

export const Subtitle = styled(Copy)`
  display: block;
  margin-top: 0.4rem;
`;

export const AdditionalInfo = styled(Copy)<{ withStatus: boolean }>`
  display: block;
  margin-top: 0.8rem;
  max-width: 85%;

  ${({ withStatus }) => (withStatus ? `max-width: 24.9rem;` : '')}
`;

export const AdditionalInfoRichText = styled.div<{ withStatus: boolean }>`
  margin-top: 0.8rem;
  max-width: 85%;
  * {
    margin-top: 0.8rem;
  }
  ${({ withStatus }) =>
    withStatus
      ? css`
          ${media('md')`
        max-width: 27.9rem;
      `}
          ${media('lg')`
        max-width: 25.2rem;
      `}
        `
      : ''}
`;
